import { render, staticRenderFns } from "./FormMultiselect.vue?vue&type=template&id=ed4c359a&"
import script from "./FormMultiselect.vue?vue&type=script&lang=js&"
export * from "./FormMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./FormMultiselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports